import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class MwInput extends Component {

  @tracked searchQuery = '';

  @action
  clearSearch() {
    this.searchQuery = '';
  }
}
